import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceInput,
  SearchInput,
  CardActions,
  Filter,
  ReferenceField,
  SelectField,
  AutocompleteInput,
  SelectInput,
  EditButton,
  NumberField,
} from "react-admin";
import QrcodeButton from "./QrcodeButton";
import UnselectAllButton from "../common/UnselectAllButton";
import ResourceBulkUpdateButton from "./ResourceBulkUpdateButton";
import ResourceSyncButton from "./ResourceSyncButton";
import EditIcon from "../../icon/IcnEdit";
import ResourcePairingButton from "./ResourcePairingButton";

const ResourceActions = ({
  bulkActions,
  basePath,
  displayedFilters,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <ResourceSyncButton />
  </CardActions>
);

const ResourceFilter = (props) => (
  <Filter {...props}>
    <SearchInput
      source="q"
      alwaysOn
      label="resources.resources.fields.search"
    />
    <ReferenceInput
      source="resourceGroupId"
      reference="resource-groups"
      sort={{ field: "name", order: "ASC" }}
      perPage={1000}
      alwaysOn
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      source="operationRuleId"
      reference="operation-rules"
      sort={{ field: "name", order: "ASC" }}
      alwaysOn
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      source="isMonitored"
      alwaysOn
      choices={[
        { id: true, name: "resources.resources.enums.monitoring.true" },
        { id: false, name: "resources.resources.enums.monitoring.false" },
      ]}
    />
  </Filter>
);

const ResourceList = (props) => (
  <List
    {...props}
    bulkActionButtons={<ResourceBulkActionButtons />}
    actions={<ResourceActions />}
    filters={<ResourceFilter />}
    sort={{ field: "name", order: "ASC" }}
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="resourceGroupName" />
      <NumberField source="capacity" />
      <ReferenceField
        source="operationRuleId"
        reference="operation-rules"
        allowEmpty={true}
        linkType={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <SelectField
        source="isMonitored"
        choices={[
          { id: true, name: "resources.resources.enums.monitoring.true" },
          { id: false, name: "resources.resources.enums.monitoring.false" },
        ]}
      />
      <QrcodeButton {...props} />
      <EditButton icon={<EditIcon />} />
    </Datagrid>
  </List>
);

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <UnselectAllButton {...props} />
    <ResourceBulkUpdateButton {...props} />
    <ResourcePairingButton {...props} />
  </Fragment>
);

export default ResourceList;
